import Rest from '../Rest';

export default class ConfigService extends Rest {

        static resource = '/configs';

        async getGeneralConfigs() {
           
                return await this.get(`/general`);          

        }

}
